import {
  ADD_RETURN_REASON, ADD_RETURN_REASON_COMPLETED, ADD_RETURN_REASON_FAILED,
  GET_RETURN_REASON, GET_RETURN_REASON_COMPLETED, GET_RETURN_REASON_FAILED,
  SEARCH_RETURN_REASONS, SEARCH_RETURN_REASONS_COMPLETED, SEARCH_RETURN_REASONS_FAILED,
  UPDATE_RETURN_REASON, UPDATE_RETURN_REASON_COMPLETED, UPDATE_RETURN_REASON_FAILED,
  UPDATE_RETURN_REASON_VISIBILITY, UPDATE_RETURN_REASON_VISIBILITY_COMPLETED, UPDATE_RETURN_REASON_VISIBILITY_FAILED,
} from "./actions";
import {getDescriptionFromError} from "../utils/errors";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  search: searchDefault,
  returnReason: null,
  fetchingReturnReason: false,
  returnReasonError: '',
  addingReturnReason: false,
  addReturnReasonError: '',
  updatingReturnReason: false,
  updateReturnReasonError: '',
  updatingReturnReasonVisibility: false,
  updateReturnReasonVisibilityError: '',
};

const reducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_RETURN_REASONS: {
      return handleSearch(state, 'search', action.payload);
    }
    case SEARCH_RETURN_REASONS_COMPLETED: {
      return handleSearchCompleted(state, 'search', action.payload);
    }
    case SEARCH_RETURN_REASONS_FAILED: {
      return handleSearchFailed(state, 'search', action.payload);
    }
    case GET_RETURN_REASON: {
      return {
        ...state,
        fetchingReturnReason: true,
      };
    }
    case GET_RETURN_REASON_COMPLETED: {
      return {
        ...state,
        returnReason: action.payload,
        fetchingReturnReason: false,
        returnReasonError: '',
      };
    }
    case GET_RETURN_REASON_FAILED: {
      return {
        ...state,
        fetchingReturnReason: false,
        returnReasonError: getDescriptionFromError(action.payload),
      };
    }
    case ADD_RETURN_REASON: {
      return {
        ...state,
        addingReturnReason: true,
      };
    }
    case ADD_RETURN_REASON_COMPLETED: {
      return {
        ...state,
        addingReturnReason: false,
        addReturnReasonError: '',
      };
    }
    case ADD_RETURN_REASON_FAILED: {
      return {
        ...state,
        addingReturnReason: false,
        addReturnReasonError: getDescriptionFromError(action.payload),
      };
    }
    case UPDATE_RETURN_REASON: {
      return {
        ...state,
        updatingReturnReason: true,
      };
    }
    case UPDATE_RETURN_REASON_COMPLETED: {
      return {
        ...state,
        updatingReturnReason: false,
        updateReturnReasonError: '',
      };
    }
    case UPDATE_RETURN_REASON_FAILED: {
      return {
        ...state,
        updatingReturnReason: false,
        updateReturnReasonError: getDescriptionFromError(action.payload),
      };
    }
    case UPDATE_RETURN_REASON_VISIBILITY: {
      return {
        ...state,
        updatingReturnReasonVisibility: true,
      };
    }
    case UPDATE_RETURN_REASON_VISIBILITY_COMPLETED: {
      return {
        ...state,
        updatingReturnReasonVisibility: false,
        updateReturnReasonVisibilityError: '',
      };
    }
    case UPDATE_RETURN_REASON_VISIBILITY_FAILED: {
      return {
        ...state,
        updatingReturnReasonVisibility: false,
        updateReturnReasonVisibilityError: getDescriptionFromError(action.payload),
      };
    }
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/ReturnReason/reducer.js